export default __webpack_public_path__ + "static/media/ring-0@2x.b7000c82.jpg";